export default class SteeringDataSourceEnum {
  static NNGT = 'NNGT';
  static MSISDN = 'MSISDN';
}
